import axios from "axios";

import { baseUrl } from "../store/slices/auth";
import { User } from "../types/user";

export type AdminRole =
  | "candidate"
  | "participant"
  | "ambassador"
  | "mentor"
  | "coordinator"
  | "super_admin"
  | "education_admin"
  | "career_manager";

export type AdminUser = Pick<
  User,
  | "_id"
  | "username"
  | "telephone"
  | "email"
  | "role"
  | "isAdmin"
  | "programAccess"
  | "cohortId"
  | "center"
  | "resume"
  | "telegram"
> & {
  createdAt?: string;
  updatedAt?: string;
};

export const adminUserRoleOptions: Array<{
  value: AdminRole;
  label: string;
  description: string;
}> = [
  {
    value: "super_admin",
    label: "Супер-адмін",
    description: "Повний доступ до платформи, ролей і налаштувань.",
  },
  {
    value: "career_manager",
    label: "Кар'єрний менеджер",
    description: "Вакансії, робота, консультації та профілі учасників.",
  },
  {
    value: "education_admin",
    label: "Освітній адмін",
    description: "Курси, модулі, завдання, календар і активності.",
  },
  {
    value: "participant",
    label: "Учасник",
    description: "Звичайний активний учасник програми.",
  },
  {
    value: "candidate",
    label: "Кандидат",
    description: "Очікує розгляду заявки або заповнює профіль.",
  },
  {
    value: "ambassador",
    label: "Амбасадор",
    description: "Випускник або представник спільноти.",
  },
  {
    value: "mentor",
    label: "Ментор",
    description: "Допомагає учасникам у навчанні та розвитку.",
  },
  {
    value: "coordinator",
    label: "Координатор",
    description: "Підтримує організаційні процеси.",
  },
];

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : undefined;
};

export const getAdminUsers = async () => {
  const response = await axios.get<{ users: AdminUser[] }>(
    `${baseUrl}admin/users`,
    getAuthConfig()
  );
  return response.data.users;
};

export const updateAdminUserRole = async (userId: string, role: AdminRole) => {
  const response = await axios.patch<{ user: AdminUser }>(
    `${baseUrl}admin/users/${userId}/role`,
    { role },
    getAuthConfig()
  );
  return response.data.user;
};

export const deleteAdminUser = async (userId: string) => {
  const response = await axios.delete<{
    message: string;
    deletedUserId: string;
  }>(`${baseUrl}admin/users/${userId}`, getAuthConfig());
  return response.data;
};

export const normalizeLegacyAdminRoles = async () => {
  const response = await axios.post<{
    message: string;
    updated: number;
    superAdmins: number;
    educationAdmins: number;
  }>(`${baseUrl}admin/users/normalize-admins`, {}, getAuthConfig());
  return response.data;
};
